<script>
  import EmbeddedPostAjax from '@ajax/embedded_posts';
  import { onDestroy } from 'svelte';
  import { getGlobalStore } from '@stores/global';
  import Carousel from '@app-components/modal/embed_posts/Carousel.svelte';
  import { browser } from '$app/environment';
  let globalStateStore = getGlobalStore('globalStateStore');
  export let mobile;
  export let group;
  export let user;
  let postInformation = null;

  let loadData = async function () {
    const response = await EmbeddedPostAjax.getPosts(group);
    postInformation = response.embedded_posts[0];
  };
  if (browser) {
    loadData();
  }
  let unsubGlobalState = globalStateStore.subscribe((x) => {
    if (x.postEmbedded) {
      postInformation = null;
      loadData();
    }
    if (x.embeddedPostDeleted) {
      postInformation = null;
    }
  });
  onDestroy(() => {
    unsubGlobalState();
  });
</script>

<style style="text/scss" lang="scss">
  .carousal-container.mobile {
    margin-top: 24px;
  }
</style>

{#if postInformation}
  <div class="carousal-container {mobile ? 'mobile' : 'desktop'}">
    <Carousel postInformation={postInformation} mobile={mobile} user={user} group={group} viewType={'group-view'}
    ></Carousel>
  </div>
{/if}
